import type { Dayjs } from 'dayjs';
import dayjs          from 'dayjs';
import currentSession from 'utils/currentSession';

export const MESSAGE_EDIT_TIME_LIMIT_MINUTES = 15;

const isMessageEditable = (itemIndex: number, createdById: id, createdAtDate: Dayjs): boolean =>
  itemIndex === 0 &&
  currentSession.user.user_id === createdById &&
  dayjs().diff(createdAtDate, 'minute') < MESSAGE_EDIT_TIME_LIMIT_MINUTES;

export default isMessageEditable;
